<template>
    <vs-sidebar parent="#chat-app" :class="(isAdmin || isModerator) && 'admin_info'" position-right default-index="1"  color="primary" spacer v-model="openInfo">
        <feather-icon class="info_close md:inline-flex lg:hidden cursor-pointer" icon="XIcon" @click="openInfo = false" />
        <div class="pt-2 pb-4">
            <div class="text-center px-2">
                <h6 :class="['text-lg font-bold truncate', isAdmin && 'cursor-pointer']" @click="changeChatName()">
                    {{openDialog.name}}
                </h6>

                <div class="pt-2">{{chatMember}}</div>
                <div v-if="isAdmin || isModerator" class="flex mt-2 justify-center">
                    <vs-button
                        class="mx-1"
                        v-if="isAdmin"
                        color="primary"
                        size="small"
                        @click="changeChatName()"
                        type="border"
                        icon-pack="feather"
                        icon="icon-edit-2" />
                    <vs-button
                        class="mx-1"
                        v-if="isAdmin || isModerator"
                        color="success"
                        @click="$store.commit('chat/SET_ADD_MEMBER_POPUP', true)"
                        size="small"
                        type="border"
                        icon-pack="feather"
                        icon="icon-user-plus" />
                    <vs-button
                        class="mx-1"
                        v-if="isAdmin"
                        color="danger"
                        size="small"
                        @click="$store.commit('chat/SET_DELETE_POPUP', true)"
                        type="border"
                        icon-pack="feather"
                        icon="icon-trash" />
                </div>
            </div>
        </div>
        <vs-divider class="d-theme-border-grey-light m-0" />
        <component
            :is="'VuePerfectScrollbar'"
            class="members_scroll"
            :settings="settings"
            @ps-y-reach-end="getChatMembers"
            :key="$vs.rtl">
                <ul class="chat__active-chats bordered-items">
                    <li class="cursor-pointer" v-for="(contact, index) in chatMembers" :key="index">
                        <ChatContact :contact="contact.user" :chatMember="contact" />
                    </li>
                </ul>
                <div v-show="status" class="vs-con-loading__container member_loader"></div>
        </component>
        <vs-popup class="popup_chat_name" title="Изменить имя чата" :active.sync="changeName">
            <form>
                <vs-input v-validate="'required'" placeholder="Введите название чата" name="chat_name" v-model="name" class="w-full" />
                <span class="text-danger text-sm" v-show="errors.has('chat_name')">{{$t('validation_required')}}</span>
                <vs-button type="filled" @click.prevent="submitForm" class="mt-4 chat_name_loader">{{$t('save')}}</vs-button>
            </form>
        </vs-popup>
    </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import ChatContact from './ChatContact.vue'
import {declOfNum} from './utils'
import {mapState} from 'vuex'
export default {
    components: {
        VuePerfectScrollbar,
        ChatContact
    },
    data() {
        return{
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.6
            },
            page: 0,
            status: true,
            loading: false,
            changeName: false,
            name: ''
        }
    },
    watch: {
        openInfo(val) {
            if(val) {
                this.getChatMembers()
            } else {
                this.page = 0
                this.status = true
                this.changeName = false
                this.name = ''
                this.loading = false
                this.$store.commit('chat/CLEAR_MEMBERS_CHAT')
                this.$store.commit('chat/SET_DELETE_POPUP', false)
            }
        }
    },
    methods: {
        async submitForm() {
            try {
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: '.chat_name_loader',
                        scale: 0.6
                    })
                })
                const res = await this.$store.dispatch('chat/changeChatName', this.name)
                if(res) {
                    this.changeName = false
                    this.$vs.notify({
                        text: this.$t('name_changed'),
                        color: 'success'
                    })
                }
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'success'
                })
            } finally {
                this.$vs.loading.close('.chat_name_loader > .con-vs-loading')
            }
        },
        changeChatName() {
            if(this.openDialog.author.profileId === this.user.profileId) {
                this.name = JSON.parse(JSON.stringify(this.openDialog.name))
                this.changeName = true
            }
        },
        async getChatMembers() {
            if(!this.loading && this.status && this.openInfo) {
                try {
                    this.$nextTick(() => {
                        this.$vs.loading({
                            container: '.member_loader',
                            background: 'transparent',
                            scale: 0.6
                        })
                    })
                    this.loading = true
                    this.page = this.page+1
                    const res = await this.$store.dispatch('chat/getChatMembers', {page: this.page})

                    if(!res.next)
                        this.status = false
                } catch(e) {

                } finally {
                    this.$vs.loading.close('.member_loader > .con-vs-loading')
                    this.loading = false
                }
            }
        }
    },
    computed: {
        ...mapState({
            openDialog: state => state.chat.openDialog,
            chatMembers: state => state.chat.chatMembers,
            user: state => state.user.user
        }),
        chatMember() {
            if(this.openDialog.is_public)
                return this.openDialog.member_count + ' ' + declOfNum(this.openDialog.member_count, [this.$t('participant'), this.$t('participant2'), this.$t('participant3')])
        },
        isAdmin() {
            if(this.openDialog.author.profileId === this.user.profileId)
                return true
        },
        isModerator() {
            if(this.openDialog.is_moderator)
                return true
        },
        openInfo: {
            get() {
                return this.$store.state.chat.openInfo
            },
            set(val) {
                this.$store.commit('chat/CHANGE_INFO', val)
            }
        }
    }
}
</script>

<style lang="scss">
@media only screen and (max-width: 886px) {
    .info_close{
        position: absolute!important;
        top: 10px;
        left: 10px;
    }
}
.popup_chat_name{
    .vs-popup{
        width: 400px;
    }
}
.members_scroll{
    height: calc(100% - 78px);
}
.admin_info{
    .members_scroll{
        height: calc(100% - 112px);
    }
}
.chat_name_loader{
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
.member_loader{
    position: relative;
    padding: 20px 0;
    .con-vs-loading{
        position: absolute;
    }
}
</style>
